import { httpPost } from 'src/utils/http';
import { SendContactOrganizerEmailRequestType } from 'src/models/contactOrganizer';

const getPath = (path: string) => `/contactorganizer/${path}`;

export const apiSendContactOrganizerEmail = (data: SendContactOrganizerEmailRequestType) =>
  httpPost(getPath('sendcontactorganizeremail'), { model: data });
